import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';

import {NavLink} from 'react-router-dom';
import {Container, Menu} from 'semantic-ui-react';

import {windowResize} from './actions/viewport';
import {toggleSidebar} from './actions/navigation';

import Page from './components/Page';
import Notifications from './containers/Notifications';

import SettingsMenu from './containers/Settings';
import {RedditSwitch, RedditSidebar} from './portfolio/api/reddit';

import './App.css';

class App extends Component {

    componentDidMount() {
        // Add global events
        window.addEventListener('resize', this.props.windowResize);
    }
    componentWillUnmount() {
        // Remove global events
        window.removeEventListener('resize', this.props.windowResize);
    }

    shouldComponentUpdate({location: {
            pathname
        }, sidebar}) {
        return pathname !== this.props.pathname || sidebar !== this.props.sidebar;
    }

    render() {
        const {history: {
                action
            }, location: {
                pathname
            }, sidebar} = this.props;
        return <div className="App">
            <Menu className="App-menu" fixed="top" size="large">
                <Menu.Item icon="sidebar" active={sidebar} onClick={this.props.toggleSidebar}/>
                <Menu.Item as={NavLink} exact={true} to='/' icon="reddit"/>
                <SettingsMenu/>
            </Menu>
            <div className="App-sidebar">
                <RedditSidebar visible={sidebar}/>
            </div>
            <div className="App-content">
                <Container as={Notifications} className="App-notifications" text={true}/>
                <Page
                    direction={action === 'PUSH'
                        ? 'left'
                        : 'right'}
                    name={pathname}>
                    <RedditSwitch/>
                </Page>
            </div>
        </div>;
    }
}

App.propTypes = {
    history: PropTypes
        .shape({action: PropTypes.string.isRequired})
        .isRequired,
    location: PropTypes
        .shape({pathname: PropTypes.string.isRequired})
        .isRequired,
    sidebar: PropTypes.bool.isRequired,
    toggleSidebar: PropTypes.func.isRequired,
    windowResize: PropTypes.func.isRequired
};
const connectedApp = connect(({navigation: {
        sidebar
    }}) => ({sidebar}), {toggleSidebar, windowResize})(App);
export default withRouter(connectedApp);



// WEBPACK FOOTER //
// ./src/App.js